/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START _label.component.scss.shim.ngstyle,_angular_core,_angular_common,_label.component PURE_IMPORTS_END */
/** PURE_IMPORTS_START _label.component.scss.shim.ngstyle,_angular_core,_angular_common,_label.component PURE_IMPORTS_END */
import * as i0 from "./label.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/common";
import * as i3 from "./label.component";
var styles_LabelComponent = [i0.styles];
var RenderType_LabelComponent = /*@__PURE__*/ i1.ɵcrt({ encapsulation: 0, styles: styles_LabelComponent, data: {} });
export { RenderType_LabelComponent as RenderType_LabelComponent };
export function View_LabelComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 4, "div", [], null, null, null, null, null)), i1.ɵdid(1, 278528, null, 0, i2.NgClass, [i1.IterableDiffers, i1.KeyValueDiffers, i1.ElementRef, i1.Renderer2], { ngClass: [0, "ngClass"] }, null), (_l()(), i1.ɵted(-1, null, ["\n    "])), i1.ɵncd(null, 0), (_l()(), i1.ɵted(-1, null, ["\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.bold ? "label bold" : "label"); _ck(_v, 1, 0, currVal_0); }, null); }
export function View_LabelComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "label", [], null, null, null, View_LabelComponent_0, RenderType_LabelComponent)), i1.ɵdid(1, 114688, null, 0, i3.LabelComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LabelComponentNgFactory = /*@__PURE__*/ i1.ɵccf("label", i3.LabelComponent, View_LabelComponent_Host_0, { bold: "bold" }, {}, ["*"]);
export { LabelComponentNgFactory as LabelComponentNgFactory };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/label/label.component.ngfactory.js
// module id = null
// module chunks = 